export enum ExperienceLicensePermission {
    None = 0,
    TravelWorthy = 1 << 1,
    PopularityScore_0 = 1 << 2,
    PopularityScore_1 = 1 << 3,
    PopularityScore_2 = 1 << 4,
    PopularityScore_3 = 1 << 5,
    PopularityScore_4 = 1 << 6,
    PopularityScore_5 = 1 << 7,
    PopularityScore_6 = 1 << 8,
    Local = PopularityScore_0 | PopularityScore_1 | PopularityScore_2 | PopularityScore_3 | PopularityScore_4 | PopularityScore_5 | PopularityScore_6,
    AllOG = Local | TravelWorthy
}
